import _slicedToArray from "/home/runner/work/partner-forms-ui/partner-forms-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/partner-forms-ui/partner-forms-ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React__default, { useState } from 'react';
import FieldBase from '../FieldBase/index.js';
import classNames from 'classnames';
var getSafeName = function getSafeName(name) {
  return name ? name : "iq-radio-field-".concat(Math.random());
};
var RadioField = function RadioField(_ref) {
  var required = _ref.required,
    errorMessage = _ref.errorMessage,
    name = _ref.name,
    label = _ref.label,
    optional = _ref.optional,
    invalid = _ref.invalid,
    tooltipConfig = _ref.tooltipConfig,
    disabled = _ref.disabled,
    _ref$maxSize = _ref.maxSize,
    maxSize = _ref$maxSize === void 0 ? true : _ref$maxSize,
    options = _ref.options,
    columns = _ref.columns,
    verticalGap = _ref.verticalGap,
    horizontalGap = _ref.horizontalGap,
    value = _ref.value,
    _onChange = _ref.onChange,
    onBlur = _ref.onBlur;
  var componentClass = classNames("iq-radio-field", _defineProperty(_defineProperty(_defineProperty({}, "iq-radio-field--max-size", !!maxSize), "iq-radio-field--disabled", !!disabled), "iq-radio-field--invalid", !!invalid));
  var _useState = useState(getSafeName(name)),
    _useState2 = _slicedToArray(_useState, 1),
    safeName = _useState2[0];
  var containerStyle = function () {
    var defaultStyle = {};
    if (columns) {
      defaultStyle.gridTemplateColumns = "repeat(".concat(columns, ", 1fr)");
    }
    if (verticalGap) {
      defaultStyle.rowGap = verticalGap;
    }
    if (horizontalGap) {
      defaultStyle.columnGap = horizontalGap;
    }
    return defaultStyle;
  }();
  function handleBlur(e) {
    var _a;
    if (!!onBlur) {
      onBlur((_a = e == null ? void 0 : e.target) == null ? void 0 : _a.value);
    }
  }
  return /* @__PURE__ */React__default.createElement("div", {
    className: componentClass
  }, /* @__PURE__ */React__default.createElement(FieldBase, {
    required: required,
    errorMessage: errorMessage,
    name: safeName,
    label: label,
    optional: optional,
    invalid: invalid,
    tooltipConfig: tooltipConfig
  }, /* @__PURE__ */React__default.createElement("div", {
    style: containerStyle,
    className: "iq-radio-field__container"
  }, options.map(function (option, index) {
    var id = "iq-radio-option-".concat(name, "-").concat(index);
    return /* @__PURE__ */React__default.createElement("div", {
      className: "iq-radio-field__option",
      key: "item-radio-".concat(safeName, "-").concat(index)
    }, /* @__PURE__ */React__default.createElement("label", {
      htmlFor: id,
      className: "iq-radio-field__option-holder"
    }, /* @__PURE__ */React__default.createElement("input", {
      className: "iq-radio-field__input",
      id: id,
      name: safeName,
      value: option == null ? void 0 : option.value,
      type: "radio",
      checked: value === option.value,
      onChange: function onChange(e) {
        var _a;
        return _onChange((_a = e == null ? void 0 : e.target) == null ? void 0 : _a.value);
      },
      onBlur: handleBlur,
      disabled: disabled
    }), /* @__PURE__ */React__default.createElement("span", {
      className: "iq-radio-field__icon"
    }), /* @__PURE__ */React__default.createElement("span", {
      className: "iq-radio-field__label"
    }, option == null ? void 0 : option.label)));
  }))));
};
export { RadioField as default };